module.exports = __webpack_public_path__ + "img/default-boy.03e0e1f7.png";